import { publicAssetsURL } from '#internal/nuxt/paths';export default publicAssetsURL("/images/blog/bg.webp")